export const COUNTRIES_MASKS = {
  AD: `+376ddd-ddd`,
  AE: `+971-dd-ddd-dddd`,
  AF: `+93dd-ddd-dddd`,
  AG: `+1(268) ddd-dddd`,
  AI: `+1(264) ddd-dddd`,
  AL: `+355(ddd) ddd-ddd`,
  AM: `+374dd-ddd-ddd`,
  AO: `+244(ddd) ddd-ddd`,
  AR: `+54(ddd) ddd-dddd`,
  AT: `+43(ddd) ddd-dddd`,
  AU: `+61d-dddd-dddd`,
  AW: `+297ddd-dddd`,
  AZ: `+994dd-ddd-dd-dd`,
  BA: `+387 ddd-dddd-dd`,
  BB: `+1(246) ddd-dddd`,
  BD: `+880dd-ddd-ddd`,
  BE: `+32(ddd) ddd-ddd`,
  BF: `+226dd-dd-dddd`,
  BG: `+359(ddd) ddd-ddd`,
  BH: `+973dddd-dddd`,
  BI: `+257dd-dd-dddd`,
  BJ: `+229dd-dd-dddd`,
  BL: `+590 dd dd dd dd dd`,
  BM: `+1(441) ddd-dddd`,
  BN: `+673ddd-dddd`,
  BO: `+591d-ddd-dddd`,
  BQ: `+599-ddd-dddd`,
  BR: `+55(dd) dddd-dddd`,
  BS: `+1(242) ddd-dddd`,
  BT: `+975d-ddd-ddd`,
  BW: `+267dd-ddd-ddd`,
  BY: `+375(dd) ddd-dd-dd`,
  BZ: `+501ddd-dddd`,
  CA: `+1(ddd) ddd-dddd`,
  CD: `+243(ddd) ddd-ddd`,
  CF: `+236-dd-dd-dddd`,
  CG: `+242dd-ddd-dddd`,
  CH: `+41dd-ddd-dddd`,
  CI: `+225dd-dd-ddd-ddd`,
  CL: `+56d-dddd-dddd`,
  CM: `+237ddddd-dddd`,
  CN: `+86(ddd) dddd-dddd`,
  CO: `+57(ddd) ddd-dddd`,
  CR: `+506dddd-dddd`,
  CU: `+53d-ddd-dddd`,
  CV: `+238(ddd) dd-dd`,
  CW: `+5999-ddd-dddd`,
  CY: `+357dd-ddd-ddd`,
  CZ: `+420(ddd) ddd-ddd`,
  DE: `+49(ddd) ddd-ddd-dd`,
  DJ: `+253dd-dd-dd-dd`,
  DK: `+45dd-dd-dd-dd`,
  DM: `+1(767) ddd-dddd`,
  DO: `+1(ddd) ddd-dddd`,
  DZ: `+213dd-ddd-dddd`,
  EC: `+593dd-ddd-dddd`,
  EE: `+372dddd-dddd`,
  EG: `+20(ddd) ddd-dddd`,
  ER: `+291d-ddd-ddd`,
  ES: `+34(ddd) ddd-ddd`,
  ET: `+251dd-ddd-dddd`,
  FI: `+358(ddd) ddd-dd-dd`,
  FJ: `+679dd-ddddd`,
  FK: `+500ddddd`,
  FM: `+691ddd-dddd`,
  FR: `+33 dd dd dd dd dd`,
  GA: `+241dd-dd-dd-dd`,
  GB: `+44dd-dddd-dddd`,
  GD: `+1(473) ddd-dddd`,
  GE: `+995(ddd) ddd-ddd`,
  GF: `+594 dd dd dd dd dd`,
  GH: `+233(ddd) ddd-ddd`,
  GI: `+350ddd-ddddd`,
  GL: `+299dd-dd-dd`,
  GM: `+220(ddd) dd-dd`,
  GN: `+224dd-ddd-ddd`,
  GP: `+590 dd dd dd dd dd`,
  GQ: `+240dd-ddd-dddd`,
  GR: `+30(ddd) ddd-dddd`,
  GT: `+502d-ddd-dddd`,
  GW: `+245d-dddddd`,
  GY: `+592ddd-dddd`,
  HK: `+852dddd-dddd`,
  HN: `+504dddd-dddd`,
  HR: `+385dd-ddd-dddd`,
  HT: `+509dd-dd-dddd`,
  HU: `+36(ddd) ddd-ddd`,
  ID: `+62(ddd) ddd-dd-ddd`,
  IE: `+353(ddd) ddd-ddd`,
  IL: `+972dd-ddd-dddd`,
  IN: `+91(dddd) ddd-ddd`,
  IQ: `+964(ddd) ddd-dddd`,
  IR: `+98(ddd) ddd-dddd`,
  IS: `+354ddd-dddd`,
  IT: `+39(ddd) dddd-ddd`,
  JM: `+1(876) ddd-dddd`,
  JO: `+962d-dddd-dddd`,
  JP: `+81-dd-dddd-dddd`,
  KE: `+254ddd-dddddd`,
  KG: `+996(ddd) ddd-ddd`,
  KH: `+855dd-ddd-ddd`,
  KM: `+269dd-ddddd`,
  KN: `+1(869) ddd-dddd`,
  KP: `+850dddd-ddddddddddddd`,
  KR: `+82dd-ddd-dddd`,
  KW: `+965dddd-dddd`,
  KY: `+1(345) ddd-dddd`,
  KZ: `+7(ddd) ddd-dd-dd`,
  LA: `+856dd-dd-ddd-ddd`,
  LB: `+961dd-ddd-ddd`,
  LC: `+1(758) ddd-dddd`,
  LI: `+423(ddd) ddd-dddd`,
  LK: `+94dd-ddd-dddd`,
  LR: `+231dd-ddd-ddd`,
  LS: `+266d-ddd-dddd`,
  LT: `+370(ddd) dd-ddd`,
  LU: `+352(ddd) ddd-ddd`,
  LV: `+371dd-ddd-ddd`,
  LY: `+218dd-ddd-dddd`,
  MA: `+212dd-dddd-ddd`,
  MC: `+377ddd-ddd-ddd`,
  MD: `+373dddd-dddd`,
  ME: `+382dd-ddd-ddd`,
  MF: `+590 dd dd dd dd dd`,
  MG: `+261dd-dd-ddddd`,
  MK: `+389dd-ddd-ddd`,
  ML: `+223dd-dd-dddd`,
  MM: `+95dd-ddd-ddd`,
  MN: `+976dd-dd-dddd`,
  MO: `+853dddd-dddd`,
  MQ: `+596 dd dd dd dd dd`,
  MR: `+222dd-dd-dddd`,
  MS: `+1(664) ddd-dddd`,
  MT: `+356dddd-dddd`,
  MU: `+230dddd-dddd`,
  MV: `+960ddd-dddd`,
  MW: `+265d-dddd-dddd`,
  MX: `+52(ddd) ddd-dddd`,
  MY: `+60(ddd) ddd-ddd`,
  MZ: `+258dd-ddd-ddd`,
  NA: `+264dd-ddd-dddd`,
  NC: `+687 ddd ddd`,
  NE: `+227dd-dd-dddd`,
  NG: `+234(ddd) ddd-dddd`,
  NI: `+505dddd-dddd`,
  NL: `+31dd-ddd-dddd`,
  NO: `+47(ddd) dd-ddd`,
  NP: `+977dd-ddd-ddd`,
  NZ: `+64(ddd) ddd-dddd`,
  OM: `+968dd-ddd-ddd`,
  PA: `+507ddd-dddd`,
  PE: `+51(ddd) ddd-ddd`,
  PF: `+689 dd dd dd dd`,
  PG: `+675(ddd) dd-ddd`,
  PH: `+63(ddd) ddd-dddd`,
  PK: `+92(ddd) ddd-dddd`,
  PL: `+48(ddd) ddd-ddd`,
  PT: `+351dd-ddd-dddd`,
  PW: `+680ddd-dddd`,
  PY: `+595(ddd) ddd-ddd`,
  QA: `+974dddd-dddd`,
  RE: `+262 dd dd dd dd dd`,
  RO: `+40dd-ddd-dddd`,
  RS: `+381dd-ddd-dddd`,
  RU: `+7 (ddd) ddd-dd-dd`,
  RW: `+250(ddd) ddd-ddd`,
  SA: `+966d-dddd-dddd`,
  SB: `+677ddd-dddd`,
  SC: `+248d-ddd-ddd`,
  SD: `+249dd-ddd-dddd`,
  SE: `+46dd-ddd-dddd`,
  SG: `+65dddd-dddd`,
  SH: `+290dddd`,
  SI: `+386dd-ddd-ddd`,
  SK: `+421(ddd) ddd-ddd`,
  SL: `+232dd-dddddd`,
  SM: `+378dddd-dddddd`,
  SN: `+221dd-ddd-dddd`,
  SO: `+252dd-ddd-ddd`,
  SR: `+597ddd-dddd`,
  ST: `+239dd-ddddd`,
  SV: `+503dd-dd-dddd`,
  SX: `+1(721) ddd-dddd`,
  SY: `+963dd-dddd-ddd`,
  SZ: `+268dd-dd-dddd`,
  TC: `+1(649) ddd-dddd`,
  TD: `+235dd-dd-dd-dd`,
  TG: `+228dd-ddd-ddd`,
  TH: `+66dd-ddd-dddd`,
  TJ: `+992dd-ddd-dddd`,
  TL: `+670ddd-ddddd`,
  TM: `+993d-ddd-dddd`,
  TN: `+216dd-ddd-ddd`,
  TO: `+676ddddd`,
  TR: `+90(ddd) ddd-dddd`,
  TT: `+1(868) ddd-dddd`,
  TW: `+886d-dddd-dddd`,
  TZ: `+255dd-ddd-dddd`,
  UA: `+380(dd) ddd-dd-dd`,
  UG: `+256(ddd) ddd-ddd`,
  US: `+1 (ddd) ddd-dddd`,
  UY: `+598d-ddd-dd-dd`,
  UZ: `+998dd-ddd-dddd`,
  VC: `+1(784) ddd-dddd`,
  VE: `+58(ddd) ddd-dddd`,
  VG: `+1(284)ddd-dddd`,
  VN: `+84(ddd) dddd-ddd`,
  VU: `+678dd-ddddd`,
  WS: `+685dd-dddd`,
  XK: `+383dd-ddd-ddd`,
  YE: `+967ddd-ddd-ddd`,
  YT: `+262 dd dd dd dd dd`,
  ZA: `+27dd-ddd-dddd`,
  ZM: `+260dd-ddd-dddd`,
  ZW: `+263d-dddddd`,
}

export type ICountriesKeys = keyof typeof COUNTRIES_MASKS
